import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import moment from 'moment';

const FLOW_LABELS = {
    OTP: 'OTP',
    CHECKOUT: 'Checkout',
    PAGOS: 'Pagos',
    NOTIFICACION_PERFIL: 'Notificación perfil',
    NOTIFICACION_DIRECCION: 'Notificación dirección',
    RECORDATORIO: 'Recordatorio',
    MARKETING: 'Marketing',
    COBRO_MASIVO: 'Cobro masivo',
    OPERACIONES: 'Operaciones',
    NOTIFICACIONES_180D: 'Notificaciones 180 días',
    DESCONOCIDO: 'Desconocido',
};

const flowLabel = (flow) => FLOW_LABELS[flow] || flow;

export class VerWhatsappSendLog extends Component {
    constructor(props) {
        super(props);
        this.onChangeFlow = this.onChangeFlow.bind(this);
        this.onChangeDateFrom = this.onChangeDateFrom.bind(this);
        this.onChangeDateTo = this.onChangeDateTo.bind(this);
        this.buscar = this.buscar.bind(this);
        this.irPaginaAnterior = this.irPaginaAnterior.bind(this);
        this.irPaginaSiguiente = this.irPaginaSiguiente.bind(this);

        this.state = {
            summary: null,
            rows: [],
            page: 1,
            pageSize: 50,
            totalPages: 1,
            total: 0,
            flow: '',
            dateFrom: '',
            dateTo: '',
        };
    }

    componentDidMount() {
        this.getSummary();
        this.getLogs(1);
    }

    getSummary() {
        var user = AuthService.getCurrentUser();
        ApiService.getWhatsappSendLogSummary(user.token).then(
            (res) => {
                if (res && res.status === 'success') {
                    this.setState({ summary: res.data });
                }
            },
            (error) => { }
        );
    }

    getLogs(page) {
        var user = AuthService.getCurrentUser();
        const params = {
            page,
            pageSize: this.state.pageSize,
        };
        if (this.state.flow) params.flow = this.state.flow;
        if (this.state.dateFrom) params.dateFrom = this.state.dateFrom;
        if (this.state.dateTo) params.dateTo = this.state.dateTo;

        ApiService.getWhatsappSendLog(user.token, params).then(
            (res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        rows: res.data,
                        page: res.pagination.page,
                        totalPages: res.pagination.totalPages || 1,
                        total: res.pagination.total || 0,
                    });
                }
            },
            (error) => { }
        );
    }

    onChangeFlow(e) {
        this.setState({ flow: e.target.value });
    }

    onChangeDateFrom(e) {
        this.setState({ dateFrom: e.target.value });
    }

    onChangeDateTo(e) {
        this.setState({ dateTo: e.target.value });
    }

    buscar(e) {
        e.preventDefault();
        this.getLogs(1);
    }

    irPaginaAnterior() {
        if (this.state.page > 1) this.getLogs(this.state.page - 1);
    }

    irPaginaSiguiente() {
        if (this.state.page < this.state.totalPages) this.getLogs(this.state.page + 1);
    }

    renderSummary() {
        const { summary } = this.state;
        if (!summary) return null;

        const flowEntries = Object.keys(summary.byFlow || {})
            .filter((flow) => flow !== 'OTP')
            .map((flow) => (
                <span key={flow} className="badge badge-light mr-2 mb-1" style={{ fontSize: '0.85rem' }}>
                    {flowLabel(flow)}: {summary.byFlow[flow]}
                </span>
            ));

        const overLimit = summary.totalNonOtp >= summary.limit;

        return (
            <div className="row">
                <div className="col-md-4">
                    <div className={`card ${overLimit ? 'border-danger' : ''}`}>
                        <div className="card-body">
                            <h6>Envíos de hoy (sin OTP)</h6>
                            <h3 className={overLimit ? 'text-danger' : ''}>
                                {summary.totalNonOtp} / {summary.limit}
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body">
                            <h6>OTP enviados hoy</h6>
                            <h3>{summary.byFlow.OTP || 0}</h3>
                            <small className="text-muted">El OTP no se bloquea por el tope diario.</small>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body">
                            <h6>Detalle por flujo</h6>
                            <div>{flowEntries.length ? flowEntries : <span className="text-muted">Sin envíos hoy</span>}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { rows, page, totalPages, total } = this.state;

        return (
            <Fragment>
                <Breadcrumb title="Registro de envíos WhatsApp" parent="Settings" />
                <div className="container-fluid">
                    {this.renderSummary()}

                    <div className="card">
                        <div className="card-header">
                            <h5>Filtros</h5>
                        </div>
                        <div className="card-body">
                            <form className="form-inline" onSubmit={this.buscar}>
                                <div className="form-group mr-3">
                                    <label className="mr-2">Flujo</label>
                                    <select className="form-control" value={this.state.flow} onChange={this.onChangeFlow}>
                                        <option value="">Todos</option>
                                        {Object.keys(FLOW_LABELS).map((flow) => (
                                            <option key={flow} value={flow}>{flowLabel(flow)}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group mr-3">
                                    <label className="mr-2">Desde</label>
                                    <input type="date" className="form-control" value={this.state.dateFrom} onChange={this.onChangeDateFrom} />
                                </div>
                                <div className="form-group mr-3">
                                    <label className="mr-2">Hasta</label>
                                    <input type="date" className="form-control" value={this.state.dateTo} onChange={this.onChangeDateTo} />
                                </div>
                                <button type="submit" className="btn btn-primary">Buscar</button>
                            </form>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <h5>Registros ({total})</h5>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Teléfono</th>
                                            <th>IP</th>
                                            <th>Flujo</th>
                                            <th>Estado</th>
                                            <th>Error</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.length === 0 && (
                                            <tr>
                                                <td colSpan="6" className="text-center">No hay registros.</td>
                                            </tr>
                                        )}
                                        {rows.map((row) => (
                                            <tr key={row.id}>
                                                <td>{moment(row.createdAt).format('DD/MM/YYYY HH:mm:ss')}</td>
                                                <td>{row.phone_number || '-'}</td>
                                                <td>{row.ip_address || 'Sistema (cron)'}</td>
                                                <td>{flowLabel(row.flow)}</td>
                                                <td>
                                                    {row.success
                                                        ? <span className="badge badge-success">Enviado</span>
                                                        : <span className="badge badge-danger">Fallido</span>}
                                                </td>
                                                <td>{row.error_message || '-'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                                <button className="btn btn-outline-secondary" disabled={page <= 1} onClick={this.irPaginaAnterior}>
                                    Anterior
                                </button>
                                <span>Página {page} de {totalPages}</span>
                                <button className="btn btn-outline-secondary" disabled={page >= totalPages} onClick={this.irPaginaSiguiente}>
                                    Siguiente
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default VerWhatsappSendLog;
